module.exports = __webpack_public_path__ + "static/img/link_logo@2x.50892fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/link_logo@2x.png
// module id = 599
// module chunks = 1